
import marked from 'marked'

marked.setOptions({
  gfm: true,
  breaks: true,
  smartLists: true
})

export default marked
